import styled from "styled-components";

export const SlideMobileCloseAllPositionsStyled = styled.div`
    text-align: center;
    
    .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 12px;
    }
    
    .pl {
        font-size: 28px;
        font-weight: 600;
        
        margin-top: 24px;
        margin-bottom: 24px;
        
        > div {
            margin-top: 4px;
            display: block;
            color: var(--color-label-secondary);
            font-size: 14px;
            font-weight: 400;
        }
    }
    
    .describe {
        font-size: 16px;
        font-weight: 400;
        margin-top: 12px;
        margin-bottom: 8px;
    }
`;